/**
 * portal/CommunityConnectPage.js — /portal/community/connect
 *
 * Discourse sends members here to sign in ("DiscourseConnect URL" in the
 * Discourse settings). We check they're signed in to Forge, ask the API to
 * sign the response, and bounce them straight back to the forum.
 */
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import ForgeLogo from "../components/logo";
import { getPortalToken, portalAPI } from "./portalApi";
import "./CommunityPortalPage.css";

export default function CommunityConnectPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const sso = params.get("sso");
    const sig = params.get("sig");
    if (!sso || !sig) { setError("This sign-in link is incomplete. Please open the community again."); return; }
    if (!getPortalToken()) {
      const back = `community/connect?sso=${encodeURIComponent(sso)}&sig=${encodeURIComponent(sig)}`;
      navigate(`/portal/login?redirect=${encodeURIComponent(back)}`, { replace: true });
      return;
    }
    portalAPI.community.sso(sso, sig)
      .then((res) => { window.location.replace(res.data.redirect); })
      .catch((err) => setError(err.message || "We couldn't sign you in to the community."));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="cmc">
      <div className="cmc__card">
        <ForgeLogo fill="#b85c38" width={44} height={44} />
        {error ? (
          <>
            <h1 className="cmc__title">Couldn't open the community</h1>
            <p className="cmc__sub">{error}</p>
            <Link to="/portal/community" className="p-btn p-btn--rust">Back to Community</Link>
          </>
        ) : (
          <>
            <div className="cmc__spinner" aria-hidden="true" />
            <h1 className="cmc__title">Signing you in to the community…</h1>
            <p className="cmc__sub">One moment — we're using your Forge account, so there's nothing else to set up.</p>
          </>
        )}
      </div>
    </div>
  );
}
